import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { Subject } from 'rxjs'
import { fadeIn } from '../../../animations/fadeIn'

@Component({
    selector: 'app-key-bitting-array',
    templateUrl: './key-bitting-array.component.html',
    styleUrls: ['./key-bitting-array.component.scss'],
    animations: [fadeIn],
    standalone: false
})
export class KeyBittingArrayComponent implements OnInit, OnDestroy {
  destroy$ = new Subject()

  @Input() kba

  constructor() {}

  /* istanbul ignore next */
  ngOnInit(): void {}

  /* istanbul ignore next */
  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  message(bit) {
    let message
    if (bit.warning) {
      message = bit.warning
    }
    if (bit.error && bit.warning) {
      message = `${message}, ${bit.error}`
    } else if (bit.error) {
      message = bit.error
    }
    return message
  }
}
